// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__y7x7s","text":"styles_text__Fh7WO"};